
import { Component, Mixins } from "vue-property-decorator";
import { IComboSelectBehavior } from "../../../../../../documaker/domain/format/objects";
import { IComboSelectBehaviorPropertyEditable, instanceOfIComboSelectBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class ComboSelectBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IComboSelectBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IComboSelectBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isComboSelectBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIComboSelectBehaviorPropertyEditable(s) && s.comboSelectBehavior().isEditable(), false);
  }

  get comboSelectBehavior(): IComboSelectBehavior {
    return this.readPropertyOrDefault(s => s.comboSelectBehavior().getValue(), { code: "", options: [] });
  }

  set comboSelectBehavior(value: IComboSelectBehavior) {
    this.writePropertyWhenValid(s => s.comboSelectBehavior().setValue(value));
  }
}
